// Single source of truth for "how do we render a customer's name?".
//
// Empresa customers store their commercial label in `razon_social`; the
// previous code in IncidentsPage / RequestsPage read `customer.nombre_fiscal`
// (a field that does NOT exist on the customer model) and rendered the literal
// string "undefined" in the customer selector dropdown — see the P0 bug
// "E007 - undefined" in Nueva Solicitud / Nueva Incidencia.
//
// Residencial: nombre + apellidos.
// Empresa:     razon_social.
// Fallbacks chain to legacy fields and finally to the customer code so the UI
// never displays "undefined" or an empty space.
export const getCustomerDisplayName = (customer) => {
  if (!customer) return "Cliente sin nombre";
  if (customer.customer_type === "EMPRESA") {
    return (
      customer.razon_social ||
      customer.nombre ||
      customer.customer_id ||
      customer.id ||
      "Cliente sin nombre"
    );
  }
  const fullName = [customer.nombre, customer.apellidos]
    .filter(Boolean)
    .join(" ")
    .trim();
  return (
    fullName ||
    customer.razon_social ||
    customer.customer_id ||
    customer.id ||
    "Cliente sin nombre"
  );
};

// Composite "code + name" label used by autocomplete dropdowns and selected
// inputs across IncidentsPage / RequestsPage. Examples:
//   • "E002 - Test Company SL"     (empresa)
//   • "R002 - Juan Pérez García"   (residencial)
//   • "E001"                        (when the display name itself is just the
//                                    code — avoids "E001 - E001" duplicate)
//   • "Cliente sin nombre"          (when everything is empty / new record)
export const getCustomerOptionLabel = (customer) => {
  if (!customer) return "Cliente sin nombre";
  const code = customer.customer_id || "";
  const name = getCustomerDisplayName(customer);
  if (!code) return name;
  if (!name || name === code) return code;
  return `${code} - ${name}`;
};
